import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { dashboardQKeys } from "@hooks/queries/dashboard/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

export const useApproveAndPayPayout = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payoutId: string) => {
      return api.post(`payouts/${payoutId}/approve-and-pay`);
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Automated mobile money payout initiated.",
        color: "blue",
      });
      // Invalidate the payouts table to show the new 'processing' status
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payouts(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payoutSummary(),
      });
    },
    onError: (res: any) => {
      console.error("[From Approve & Pay Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
